import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ICurrentSubscription } from 'src/app/shared/interfaces/subscription.interface';
import { Router } from '@angular/router';
import { JWTService } from 'src/app/apv/core/services/jwt/jwt.service';
import { IUserData } from 'src/app/shared/interfaces/user.interface';
import { Location } from '@angular/common';
import { MAIL_REGEX } from 'src/app/shared/common/constants';
import { MF_SECURITY_DATA } from './modify-regimen.constants';

@Component({
    selector: 'app-modify-regimen',
    templateUrl: './modify-regimen.component.html',
    styleUrls: ['./modify-regimen.component.scss'],
    standalone: false
})
export class ModifyRegimenComponent implements OnInit {
  subscriptionDataToModify!: ICurrentSubscription;
  showSpinner = false;
  disabledConfirmationButton = false;
  disableEditAndExitButtons = false;
  user!: IUserData;
  frmEmployerMail!: FormGroup;
  showConfirmationWindowBool: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly jwtService: JWTService,
    private readonly formBuilder: FormBuilder,
    private readonly location: Location
  ) {}

  ngOnInit(): void {
    this.getDataFromStorage();
    this.user = this.jwtService.getUserDataFromToken();

    this.frmEmployerMail = this.formBuilder.group({
      email: [
        this.subscriptionDataToModify.employerEmail,
        Validators.compose([
          Validators.required,
          Validators.pattern(MAIL_REGEX),
        ]),
      ],
    });
  }

  getDataFromStorage() {
    const subscriptionData = sessionStorage.getItem('subscriptionDataToModify');
    if (subscriptionData) {
      this.subscriptionDataToModify = JSON.parse(subscriptionData);
    }
  }

  getOtherRegimen(regimen: string): string {
    switch (regimen) {
      case 'A':
        return 'B';
      case 'B':
        return 'A';
      default:
        return '';
    }
  }

  get isActiveButtonConfirmation() {
    return this.disabledConfirmationButton;
  }

  async submitModifyRegimen() {
    this.disabledConfirmationButton = true;
    this.disableEditAndExitButtons = true;
    this.showSpinner = true;

    if (this.subscriptionDataToModify) {
      const subscriptionDataNew = {
        name: this.user.name,
        email: this.user.email,
        taxRegimeCode: this.getOtherRegimen(
          this.subscriptionDataToModify.taxRegimeCode
        ),
        oldTaxRegimeCode: this.subscriptionDataToModify.taxRegimeCode,
        requestNumber: +this.subscriptionDataToModify.requestNumber,
        employer: {
          rut: +this.subscriptionDataToModify.employerRut.slice(0, -1),
          checkDigit: String(this.subscriptionDataToModify.employerRut.slice(-1)),
          name: this.subscriptionDataToModify.employerName,
          email: this.frmEmployerMail.get('email')?.value,
          address: this.subscriptionDataToModify.employerAddress,
        },
      };
      sessionStorage.setItem(
        'DataToModifyRegimeCCV',
        JSON.stringify(subscriptionDataNew)
      );
      await this.router.navigateByUrl('/home/ccv/security/keys-generic', {
        state: this.buildDataToSendToSecurityMf(),
      });

      this.resetDataLoading();
    }
  }

  handleMailInputChange() {
    this.disabledConfirmationButton = this.frmEmployerMail.get('email')
      ?.invalid as boolean;
  }

  updateClassContinueButtonFirstScreen() {
    if (this.disabledConfirmationButton) {
      return 'button-disable';
    }

    return 'primary-button';
  }

  updateClassArrowNextButton() {
    if (this.disabledConfirmationButton) {
      return 'grey';
    }

    return 'white';
  }

  public goBackToFirstScreen() {
    this.showConfirmationWindowBool = false;
  }

  public goToSecondScreen() {
    this.showConfirmationWindowBool = true;
  }

  private buildDataToSendToSecurityMf() {
    return {
      urlSuccess: MF_SECURITY_DATA.urlSuccess,
      urlGoBack: MF_SECURITY_DATA.urlGoBack,
      titleText: MF_SECURITY_DATA.titleText,
      subtitleText: MF_SECURITY_DATA.subtitleText,
    };
  }

  private resetDataLoading() {
    this.disabledConfirmationButton = false;
    this.disableEditAndExitButtons = false;
    this.showSpinner = false;
  }
}
